module.exports = __webpack_public_path__ + "static/media/ard-kka_interaktive_grafik@2x.1124e853.jpg";